import React from 'react'
import { Button } from 'components/button/Button'
import { BellIcon } from 'assets/svg/svgs'
import { ButtonStylesEnum } from 'types/buttonStylesEnum'
import './updateModal.scss'
import { useTranslation } from 'react-i18next'

interface UpdateModalProps {
    onUpdate: () => void
    message?: string
}

export const UpdateModal: React.FC<UpdateModalProps> = ({
    onUpdate,
    message
}) => {
    const { t } = useTranslation()

    return (
        <div className="update-modal" aria-label="update-modal">
            <div className="update-modal__icon">
                <BellIcon width="50" height="50" />
            </div>

            <div className="update-modal__header">
                {t('updateModal.header')}
            </div>

            <div className="update-modal__message">
                {message || t('updateModal.message')}
            </div>

            <div className="update-modal__button">
                <Button
                    style={ButtonStylesEnum.PRIMARY}
                    onClick={onUpdate}
                    size="large"
                    ariaLabel="update-modal-confirm-button"
                >
                    {t('updateModal.buttonText')}
                </Button>
            </div>
        </div>
    )
}
